import React from 'react';

class PrintLink extends React.Component{

    handlePrintClick= () =>{
          window.print();
    };
    render() {
        return(
            <a className='ConfirmationPageDisclaimer__print' onClick={this.handlePrintClick}> <u>{this.props.children}</u></a>
            
        );
    }

}
export default PrintLink;